import { z } from 'zod'
import { DEFAULT_SKILL_CATEGORY_ID } from '~/constants/skill-category'
import { ErrorCode } from '~/types/error'

// Text fields only — the icon is uploaded via a separate multipart endpoint
// (`POST /admin/skills/:id/icon`) and is tracked outside react-hook-form.
export const skillSchema = z.object({
  nameEn: z.string().min(1, ErrorCode.REQUIRED).max(100, ErrorCode.TOO_LONG),
  nameJa: z.string().min(1, ErrorCode.REQUIRED).max(100, ErrorCode.TOO_LONG),
  // Optional on the server (defaults to the 'skill' category) but the web
  // form always submits one of the fixed category ids, defaulting to
  // 'skill' on create so the select is never left unselected (HER-349).
  categoryId: z.string().min(1, ErrorCode.REQUIRED).default(DEFAULT_SKILL_CATEGORY_ID),
  isActive: z.boolean().default(true),
})

export type SkillFormData = z.infer<typeof skillSchema>
